import { Resolution } from '@blockscout/stats-types';
import type { StatsIntervalIds } from 'types/client/stats';

import type { TranslationKey } from 'lib/i18n/types';

export const STATS_RESOLUTIONS: Array<{ id: Resolution; titleKey: TranslationKey }> = [
  {
    id: Resolution.DAY,
    titleKey: 'stats.resolution.day',
  },
  {
    id: Resolution.WEEK,
    titleKey: 'stats.resolution.week',
  },
  {
    id: Resolution.MONTH,
    titleKey: 'stats.resolution.month',
  },
  {
    id: Resolution.YEAR,
    titleKey: 'stats.resolution.year',
  },
];

export const STATS_INTERVALS: { [key in StatsIntervalIds]: { titleKey: TranslationKey; shortTitleKey: TranslationKey; start?: Date } } = {
  all: {
    titleKey: 'stats.interval.all',
    shortTitleKey: 'stats.interval.all',
  },
  oneMonth: {
    titleKey: 'stats.interval.one_month',
    shortTitleKey: 'stats.interval.one_month',
    start: getStartDateInPast(1),
  },
  threeMonths: {
    titleKey: 'stats.interval.three_months',
    shortTitleKey: 'stats.interval.three_months',
    start: getStartDateInPast(3),
  },
  sixMonths: {
    titleKey: 'stats.interval.six_months',
    shortTitleKey: 'stats.interval.six_months',
    start: getStartDateInPast(6),
  },
  oneYear: {
    titleKey: 'stats.interval.one_year',
    shortTitleKey: 'stats.interval.one_year',
    start: getStartDateInPast(12),
  },
};

function getStartDateInPast(months: number): Date {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date;
}
